module.exports = __webpack_public_path__ + "static/media/error.0f4332f2.png";